import axiosInstance from "./axiosInstance";

export const obtenerNoches = async (id, signal) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerNoches?titularId=${id}`,
    {
      withCredentials: true,
      signal,
    }
  );
};
